import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-social-proof-section',
  standalone: true,
  imports: [CommonModule, MatCardModule, RouterLink],
  templateUrl: './social-proof-section.component.html',
  styleUrls: ['./social-proof-section.component.scss']
})
export class SocialProofSectionComponent {
  proofSnippets = [
    {
      organization: 'Northwest Society of Colon and Rectal Surgeons',
      communityType: 'Regional surgical society',
      outcome: 'Centralizes renewals, annual meetings, directories, and member reporting for a specialty society workflow.',
      logo: '/img/communities/nwscrs.webp',
      route: '/case-studies/northwest-society-of-colon-and-rectal-surgeons'
    },
    {
      organization: 'South Asian American Vascular Society',
      communityType: 'Physician specialty society',
      outcome: 'Supports membership operations, event participation, payments, and communication from one branded portal.',
      logo: '/img/communities/saavs.webp',
      route: '/case-studies/south-asian-american-vascular-society'
    },
    {
      organization: 'Women Physician Entrepreneurs of Houston',
      communityType: 'Physician founder network',
      outcome: 'Gives members a modern hub for events, directory access, and community updates without manual admin overhead.',
      logo: '/img/communities/wpeh.webp',
      route: '/case-studies/women-physician-entrepreneurs-of-houston'
    }
  ];
}
